export class LogType {
    static APPOINTMENT_CREATED = 'Appointment created';
    static APPOINTMENT_CANCELED = 'Appointment canceled';
    static APPOINTMENT_CONFIRMED = 'Appointment confirmed';
    static APPOINTMENT_MESSAGE_ALL = 'Message sent to all';
    static APPOINTMENT_MESSAGE_ALL_CIMA = 'Message sent to all through CIMA';
    static EXPERT_CONFIRMED_APPOINTMENT = 'Expert confirmed appointment';
    static EXPERT_RESUBMIT_APPOINTMENT = 'Expert resubmitted appointment';
    static EXPERT_CLOSED_CONSULT = 'Expert closed appointment';
    static APPOINTMENT_CLOSED = 'Appointment consultation closed';
    static APPOINTMENT_RESUBMIT_HOSPITAL = 'Appointment resubmitted by hospital';
    static INVITE_EXPERT = 'Expert invited';
    static INVITE_MULTIPLE_EXPERT = 'Multiple experts invited';
    static EXPERT_REPLACED = 'Expert replaced';
    static CANCEL_COVERAGE_NOTICE = 'Coverage noticed canceled sent';
    static APPOINTMENT_TIME_UPDATED = 'Appointment time updated';
    static LOCATION_REMINDER = 'Sent location reminder notification';
    static LOCATION_REMINDER_CIMA = 'Sent location reminder notification through CIMA';
    static EXPERT_REMINDER = 'Sent expert reminder notification';
    static EXPERT_REMINDER_CIMA = 'Sent expert reminder notification through CIMA';
    static DOCTOR_REMINDER = 'Sent doctor reminder notification';
    static DOCTOR_REMINDER_CIMA = 'Sent doctor reminder notification through CIMA';
    static RESCHEDULE_NEW_EXPERT = 'Appointment rescheduled with new expert';
    static RESCHEDULED = 'Appointment rescheduled';
    static EXPERT_REQUEST_RESCHEDULE = 'Experted requested reschedule';
    static RELEVANT_LAB_SAVED = 'Relevant lab(s) saved';
    static RELEVANT_LAB_UPDATED = 'Relevant lab updated';
    static SUBMIT_ADDITIONAL_NOTES = 'Additional notes submitted by expert';
    static EXPERT_REQUEST_ADDITIONAL_NOTES = 'Expert requested additional notes';
    static ZOOM_MEETING_CREATED = 'Zoom meeting created';
    static EXPERT_JOINED_ZOOM = 'Expert joined zoom meeting';
    static DOCTOR_JOINED_ZOOM = 'Doctor joined zoom meeting';
    static DOCTOR_MESSAGES = 'New doctor/admin message added';
}